import { Component, Input, ViewChild } from '@angular/core';
import { PlatformModel } from './platform.model';
import { DialogComponent } from 'src/app/_shared/components/dialog/dialog.component';

@Component({
  selector: 'platforms-calendar-dialog',
  templateUrl: './platforms-calendar-dialog.component.html',
  styleUrls: ['./platforms-calendar-dialog.component.scss'],
})
export class PlatformsCalendarDialogComponent {
  
  @ViewChild('dialog') dialog!: DialogComponent;

  @Input()
  platforms: PlatformModel[];

  addToCalendar(link: string) {
    window.open(link);
  }
}
